import React, { type FunctionComponent, useState } from 'react'
import { colors, useBooleanState } from '@retailer-platform/shared-components'
import { useCoreContext } from '../../../../utils/core/RPPCoreContext'
import { NavContext } from './NavContext'

interface NavProviderProps {
  navType: 'retailer-scoped' | 'admin' | 'dev-portal'
}

const navStyleContext = {
  'retailer-scoped': {
    backgroundColor: colors.GRAYSCALE.X70,
    contentColor: colors.GRAYSCALE.X0,
    iconColor: 'systemGrayscale00',
  },
  admin: {
    backgroundColor: colors.GRAYSCALE.X10,
    contentColor: colors.GRAYSCALE.X50,
    iconColor: 'systemGrayscale50',
  },
  'dev-portal': {
    backgroundColor: colors.GRAYSCALE.X0,
    contentColor: colors.GRAYSCALE.X70,
    iconColor: 'systemGrayscale50',
  },
} as const

export const NavProvider: FunctionComponent<NavProviderProps> = ({ navType, children }) => {
  const [isNavOpen, openNav, closeNav] = useBooleanState(false)
  const [folderControlledByTour, setFolderControlledByTour] = useState('')
  const [isBlockedByModal, setIsBlockedByModal] = useState(false)

  const {
    domainNavigationEntries = {},
    domainAdminNavigationEntries = {},
    domainDevPortalNavigationEntries = {},
  } = useCoreContext()

  const domainEntry = () => {
    if (navType === 'admin') return domainAdminNavigationEntries
    return navType === 'dev-portal' ? domainDevPortalNavigationEntries : domainNavigationEntries
  }

  const navTypeSpecificContext = {
    navigationEntries: domainEntry(),
    ...navStyleContext[navType],
  }

  const contextValue = {
    isNavOpen,
    openNav,
    closeNav,
    folderControlledByTour,
    setFolderControlledByTour,
    isBlockedByModal,
    setIsBlockedByModal,
    ...navTypeSpecificContext,
  }

  return <NavContext.Provider value={contextValue}>{children}</NavContext.Provider>
}
